import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { IconButton, Box } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";

const CustomDateTimePicker = ({
    label,
    name,
    value,
    onChange,
    touched,
    errors,
    format = "HH:mm dd/MM/yyyy",
    minDate,
    maxDate,
    size,
    variant = "filled",
    sx,
}) => {
    const handleClear = () => {
        onChange(name, null);
    };

    return (
        <Box sx={{ position: 'relative', ...sx }}>
            <DateTimePicker
                label={label}
                name={name}
                value={value}
                format={format}
                minDate={minDate}
                maxDate={maxDate}
                onChange={(newValue) => onChange(name, newValue)}
                slotProps={{
                    textField: {
                        variant,
                        fullWidth: true,
                        size,
                        error: !!touched?.[name] && !!errors?.[name],
                        helperText: touched?.[name] && errors?.[name],
                    },
                }}
            />
            {value && (
                <IconButton 
                    onClick={handleClear}
                    aria-label="clear date"
                    sx={{ 
                        position: 'absolute',
                        right: 35, 
                        top: '50%',
                        transform: 'translateY(-50%)',
                        '&:hover': {
                            backgroundColor: 'action.hover'
                        }
                    }}
                >
                    <ClearIcon />
                </IconButton>
            )}
        </Box>
    );
};

export default CustomDateTimePicker;